import { contracts } from "@campgladiator/cg-common.config.config";
import { SubscriptionDTO } from "@campgladiator/cg-common.types.types";
import { useEffect, useState } from "react";

const useTermsAndConditions = ({
  subscriptionProductType,
  hasTrainerGrants,
}: {
  subscriptionProductType: SubscriptionDTO["productType"];
  hasTrainerGrants: boolean;
}) => {
  const [termsUrl, setTermsUrl] = useState<string>("");

  const getTermsDocument = (
    subscriptionProductType: SubscriptionDTO["productType"]
  ) => {
    const termsDocument = hasTrainerGrants
      ? contracts.boldBig5
      : subscriptionProductType === "BOOTCAMP"
      ? contracts.camp
      : subscriptionProductType === "NUTRITION"
      ? contracts.nutrition
      : subscriptionProductType === "STRENGTH"
      ? contracts.strength
      : "";
    setTermsUrl(termsDocument);
  };

  useEffect(() => {
    getTermsDocument(subscriptionProductType);
  }, [subscriptionProductType]);

  return { termsUrl, getTermsDocument };
};

export default useTermsAndConditions;
